<template>
  <div class="my-10">
    <div class="flex flex-row flex-wrap">
      <h1 class="text-center text-l">
        <strong>{{ standard }} - {{ $t(name) }}</strong>
      </h1>
    </div>
    <div class="flex flex-row flex-wrap">
      <div class="w-full lg:w-1/5 py-10" v-if="sgs">
        <a
          href="https://www.sgs.com/en/certified-clients-and-products#590"
          target="_blank"
        >
          <img :src="src" :alt="alt" class="w-40 block m-auto" />
        </a>
      </div>
      <div class="w-full lg:w-1/5 py-10" v-else>
        <img :src="src" :alt="alt" class="w-40 block m-auto" />
      </div>

      <div
        v-html="$t(contentName)"
        class="w-full lg:w-3/5 py-5 px-4 md:px-10"
      ></div>
      <div class="w-full lg:w-1/5">
        <div class="flex flex-row items-end justify-items-end gap-1">
          <button
            @click="downloadFile(filePath, standard)"
            class="btn h-32 w-full text-center text-4xl mt-10"
          >
            <i class="fa fa-download"></i>
          </button>
          <button
            v-if="filePath2"
            @click="downloadFile(filePath2, standard2)"
            class="btn h-32 w-full text-center text-4xl mt-10"
          >
            <i class="fa fa-download"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    contentName: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    standard: {
      type: String,
      required: true
    },
    standard2: {
      type: String,
      required: false
    },
    filePath: {
      type: String,
      required: true
    },
    filePath2: {
      type: String,
      required: false
    },
    sgs: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    downloadFile(filePath, fileName) {
      const link = document.createElement('a');
      link.href = filePath;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>

<style scoped></style>
